export default {
  data() {
    return {
      forceRecomputeCounter: 0,
    };
  },

  computed: {
    interfaceValue: {
      get() {
        return Array.isArray(this.fieldValue) ? this.fieldValue : [];
      },
      set(val) {
        const e = this.forceRecomputeCounter; //eslint-disable-line
        this.$emit('change', val);
      },
    },
  },

  methods: {
    // to handle tabbing behaviour
    fakeClickOnInput(optionId) {
      const target = this.generateSafeId(this.fieldQuestionId, optionId, 'ref');
      this.$refs[target][0].click();
    },
  },
};
